import {DeviceType} from 'ngx-device-detector';

/**
 * @enum {number} AuthRequestType - The type of request that is sent to the server
 */
export enum AuthRequestType {
	Login = 0,
	RefreshToken = 1,
}

export type RemoteIpAddress = DeviceType;
